
export function GetTags(ids,mastertags,ready) {
    if (!ready || !Array.isArray(mastertags)) return []; 
    // console.log("ready and array are true")
    if (!Array.isArray(ids) || ids.length === 0) return [];
    const numericIds = ids.map(Number);
    return mastertags.filter((record) => numericIds.includes(Number(record.id)));
  }

export const generatePostMessage=(item,username)=>{
const message=

`Hello, 
I would like to inquire about the property
titled as ${item.title} at
${item.address1}, ${item.address2}. 
  
Could you please provide more details? 
  
Thank you!
${username}
  `
return message;
}

  
export const generatePassword = () => {
    const letters = "abcdefghijklmnopqrstuvwxyz";
    const specials = "!@#$%^&*()_+{}[]<>?";
    const digits = "0123456789";

    const getRandom = (chars, length) =>
      Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join("");

    const part1 = getRandom(letters, 5);   // xxxx
    const part2 = getRandom(specials, 1); // #@
    const part3 = getRandom(digits, 5);   // 9999

    return part1 + part2 + part3;
  };

  

export function guessDaysFromDuration(duration) {
  switch (duration.toLowerCase()) {
    case 'monthly':
    case '1 month':
      return 30;
    case 'quaterly':
    case 'quarter':
    case 'quater':
      return 90;
    case 'half year':
    case 'half-yearly':
      return 180;
    case 'annual':
    case 'annualy': 
      return 365;
    default:
      return 0; // Fallback
  }
}




export function parseArrayField  (value)  {
  // this function will be used to conver any string filed to array
  // "[{"key":"value"}]" to [{"key":"value"}]

  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};


export function formatToIndianRupees(amount) {
  if (amount === null || amount === undefined) return "";
  if (isNaN(amount)) return amount;

  const absAmount = Math.abs(amount);

  let formatted = "";
  if (absAmount >= 1_00_00_000) { // 1 crore
    formatted = (amount / 1_00_00_000).toFixed(2) + " Cr";
  } else if (absAmount >= 1_00_000) { // 1 lakh
    formatted = (amount / 1_00_000).toFixed(2) + " Lakh";
  } else if (absAmount >= 1_000) { // 1 thousand
    formatted = (amount / 1_000).toFixed(2) + " K";
  } else {
    formatted = amount.toString();
  }

  // return "₹ " + formatted;
  return formatted;

}


export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day},${month},${year}`;
};


export const formatMonthYear = (dateString) => {
  const date = new Date(dateString);

  return date.toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  }).replace(" ", ", ");
};
